import { makeTextComponent } from './makeTextComponent'

export const Title = makeTextComponent(
  'font-size-largest font-weight-medium font-family-title',
  'h1'
)
